export default (function (theme) {
  var typography = theme.typography;
  var fontWeightRegular = typography.fontWeightRegular,
      fontWeightMedium = typography.fontWeightMedium,
      pxToRem = typography.pxToRem;
  var fontWeightSemiBold = 600;
  var valueSerif = ['Value Serif', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'].join(','); // TODO: Define caption settings
  // TODO: Define subtitle1 and subtitle2 settings
  // TODO: Define overline settings

  return {
    fontFamily: ['Apercu Pro', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    letterSpacing: 0,
    fontWeightSemiBold: fontWeightSemiBold,
    h1: {
      fontSize: pxToRem(30),
      fontWeight: fontWeightMedium,
      letterSpacing: pxToRem(-0.1),
      lineHeight: pxToRem(36)
    },
    h2: {
      fontSize: pxToRem(25),
      fontWeight: fontWeightMedium,
      letterSpacing: pxToRem(-0.8),
      lineHeight: pxToRem(32)
    },
    h3: {
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      letterSpacing: pxToRem(-0.1),
      lineHeight: pxToRem(28)
    },
    h4: {
      fontSize: pxToRem(17),
      fontWeight: fontWeightMedium,
      lineHeight: pxToRem(24)
    },
    h5: {
      fontSize: pxToRem(15),
      fontWeight: fontWeightMedium,
      letterSpacing: pxToRem(-0.1),
      lineHeight: pxToRem(24)
    },
    h6: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      letterSpacing: pxToRem(-0.1),
      lineHeight: pxToRem(24)
    },
    body1: {
      fontSize: pxToRem(15),
      fontWeight: fontWeightRegular,
      lineHeight: pxToRem(24)
    },
    body2: {
      fontSize: pxToRem(13),
      fontWeight: fontWeightRegular,
      lineHeight: pxToRem(20)
    },
    button: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      lineHeight: pxToRem(14),
      letterSpacing: pxToRem(1)
    },
    label: {
      fontSize: pxToRem(13),
      fontWeight: fontWeightSemiBold,
      lineHeight: pxToRem(20)
    },
    caption: {
      fontSize: pxToRem(13),
      fontWeight: fontWeightRegular,
      lineHeight: pxToRem(20)
    },
    // Value-Serif Defs
    // VSTypography component uses these
    h1v: {
      xs: {
        fontFamily: valueSerif,
        fontSize: pxToRem(28),
        lineHeight: pxToRem(34)
      },
      sm: {
        fontFamily: valueSerif,
        fontSize: pxToRem(40),
        letterSpacing: pxToRem(-0.5),
        lineHeight: pxToRem(48)
      },
      md: {
        fontFamily: valueSerif,
        fontSize: pxToRem(56),
        lineHeight: pxToRem(60)
      }
    },
    h2v: {
      xs: {
        fontFamily: valueSerif,
        fontSize: pxToRem(24),
        letterSpacing: pxToRem(-0.08),
        lineHeight: pxToRem(30)
      },
      sm: {
        fontFamily: valueSerif,
        fontSize: pxToRem(36),
        letterSpacing: pxToRem(-0.1),
        lineHeight: pxToRem(36)
      },
      md: {
        fontFamily: valueSerif,
        fontSize: pxToRem(40),
        letterSpacing: pxToRem(-0.5),
        lineHeight: pxToRem(48)
      }
    },
    h3v: {
      xs: {
        fontFamily: valueSerif,
        fontSize: pxToRem(20),
        letterSpacing: pxToRem(0),
        lineHeight: pxToRem(24)
      },
      sm: {
        fontFamily: valueSerif,
        fontSize: pxToRem(24),
        letterSpacing: pxToRem(-0.08),
        lineHeight: pxToRem(30)
      },
      md: {
        fontFamily: valueSerif,
        fontSize: pxToRem(30),
        letterSpacing: pxToRem(-0.1),
        lineHeight: pxToRem(36)
      }
    },
    h4v: {
      fontFamily: valueSerif,
      fontSize: pxToRem(24),
      letterSpacing: pxToRem(-0.15),
      lineHeight: pxToRem(30)
    }
  };
});